// extracted by mini-css-extract-plugin
export default {"goTopBtn":"GoTop_goTopBtn__cfSBl"};